import { useI18n } from "@/context/I18nContext";

import { Check } from "lucide-react";
import { euroInt } from "@/lib/format";
import { Input } from "@/components/ui/input";

const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-");

export const ColorPicker = ({ colors, value, onPick, priceOf, ralText = "", onRalText, extra }) => {
  const { t } = useI18n();
  const current = colors.find((c) => c.name === value);
  const groups = [["standard", t("Couleurs standards · sans surcoût")], ["special", t("Couleurs spéciales · en option")]];
  return (
    <div className="rounded-xl border border-border bg-card p-4" data-testid="color-picker">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-3">
        <span className="text-sm font-semibold uppercase tracking-wide">{t("Couleur")}</span>
        <span className="text-sm" data-testid="color-selected">
          {current ? t(current.name) : "—"}
          {!extra && current?.type === "special" && priceOf(current) > 0 && <span className="text-primary font-mono ml-2" data-testid="color-price">+ {euroInt(priceOf(current))} TTC</span>}
        </span>
      </div>
      <div className="flex flex-wrap items-end justify-between gap-4">
      <div className="space-y-3">
        {groups.map(([type, label]) => {
          const list = colors.filter((c) => c.type === type);
          if (!list.length) return null;
          return (
            <div key={type}>
              <div className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground mb-1.5">{label}</div>
              <div className="flex flex-wrap gap-2">
                {list.map((c) => {
                  const on = c.name === value;
                  const ral = /ral/i.test(c.name);
                  return (
                    <button key={c.name} type="button" onClick={() => onPick(c)} title={c.name}
                      data-testid={`color-${slug(c.name)}`}
                      className={`relative w-10 h-10 rounded-md border transition-transform hover:scale-105 ${on ? "ring-2 ring-primary ring-offset-2 border-primary" : "border-border"}`}
                      style={{ background: ral ? "repeating-linear-gradient(45deg, #ffffff 0 6px, #d32f2f 6px 9px)" : c.hex }}>
                      {on && <Check className="absolute inset-0 m-auto w-4 h-4 text-white mix-blend-difference" />}
                    </button>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      {extra}
      </div>
      {current && /ral/i.test(current.name) && onRalText && (
        <div className="mt-3 flex items-center gap-2">
          <span className="text-sm font-medium shrink-0">{t("Précisez :")}</span>
          <Input value={ralText} onChange={(e) => onRalText(e.target.value)} placeholder={t("Ex. RAL 5015 bleu ciel")}
            className="h-9 max-w-sm" data-testid="color-ral-text" />
        </div>
      )}
    </div>
  );
};
